import { driver } from "driver.js";
import "driver.js/dist/driver.css";

let activeTutorial = null;

/**
 * Plugin de Tutorial Global
 * 
 * Uso en componentes (Options API):
 * this.$tutorial.start([
 *   { element: '#btn-guardar', title: 'Guardar', text: 'Presiona aquí para guardar cambios' },
 *   { element: '#sidebar', title: 'Menú', text: 'Navega por las opciones aquí' }
 * ]);
 * 
 * Uso en Composition API:
 * import { tutorial } from '@/plugins/tutorial';
 * tutorial.start([...]);
 */

export const tutorial = {
  // Registra la función de tutorial del componente actual
  set: (fn) => {
    activeTutorial = fn;
  },
  // Ejecuta el tutorial registrado (llamado desde el Sidebar)
  play: () => {
    if (typeof activeTutorial === 'function') {
      activeTutorial();
    }
  },
  // Inicia el tutorial recibiendo un array de pasos
  start: (steps = []) => {
    const driverObj = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      // Configuración de textos en español
      nextBtnText: 'Siguiente',
      prevBtnText: 'Anterior',
      doneBtnText: 'Finalizar',
      steps: steps.map(step => ({
        element: step.element, // Selector CSS (ej: '#id', '.clase')
        popover: {
          title: step.title || 'Ayuda',
          description: step.text,
          side: step.position || 'bottom', // top, bottom, left, right
          align: 'start'
        }
      }))
    });

    driverObj.drive();
  }
};

export default {
  install: (app) => {
    // Lo hace accesible globalmente como this.$tutorial
    app.config.globalProperties.$tutorial = tutorial;
    // Proveer para inyección en Composition API
    app.provide('tutorial', tutorial);
  }
};
